/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplatesControllerDownloadBlankTemplateQueryResponse } from "../../models/checklistsController/TemplatesControllerDownloadBlankTemplate";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { templatesControllerDownloadBlankTemplate } from "../../clients/checklistsService/templatesControllerDownloadBlankTemplate";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const templatesControllerDownloadBlankTemplateQueryKey = () => [{
  url: '/api/v1/checklist-templates/blank-template'
}] as const;
export type TemplatesControllerDownloadBlankTemplateQueryKey = ReturnType<typeof templatesControllerDownloadBlankTemplateQueryKey>;
export function templatesControllerDownloadBlankTemplateQueryOptions(config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = templatesControllerDownloadBlankTemplateQueryKey();
  return queryOptions<TemplatesControllerDownloadBlankTemplateQueryResponse, ResponseErrorConfig<Error>, TemplatesControllerDownloadBlankTemplateQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return templatesControllerDownloadBlankTemplate(config);
    }
  });
}

/**
 * @description Generates an empty 5-tab Excel file with headers only, suitable as a starting point for building templates via import.
 * @summary Download blank checklist template Excel file
 * {@link /api/v1/checklist-templates/blank-template}
 */
export function useTemplatesControllerDownloadBlankTemplate<TData = TemplatesControllerDownloadBlankTemplateQueryResponse, TQueryData = TemplatesControllerDownloadBlankTemplateQueryResponse, TQueryKey extends QueryKey = TemplatesControllerDownloadBlankTemplateQueryKey>(options: {
  query?: Partial<QueryObserverOptions<TemplatesControllerDownloadBlankTemplateQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? templatesControllerDownloadBlankTemplateQueryKey();
  const query = useQuery({
    ...templatesControllerDownloadBlankTemplateQueryOptions(config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}